import React from 'react';
import { useIntl } from 'react-intl';
import './SystemStyles.scss';

function NoAvailableSectionsPage() {
  const { formatMessage } = useIntl();
  return (
    <div className="not-found-page-wrapper">
      <div className="not-found-page">
        <div className="not-found-block-wrapper">
          <div className="not-found-block-border">
            <div className="not-found-block">
              <div className="text-1">403</div>
              <div className="text-2">{formatMessage({ id: 'permission.no.available.sections' })}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoAvailableSectionsPage;
